import { ManagementGrid } from '@/routes/admin/components/ManagementGrid/ManagementGrid'
import { ManagementGridExtendedColumn } from '@/routes/admin/components/ManagementGrid/types'

export const Auto = () => {
  const columns = [
    {
      dataField: 'id',
      caption: 'Id',
    },
    {
      dataField: 'modello',
      caption: 'Modello',
    },
    {
      dataField: 'targa',
      caption: 'Targa',
    },
  ] satisfies ManagementGridExtendedColumn[]
  return (
    <div className="content-block dx-card wide-card">
      <ManagementGrid
        endpoint={`${import.meta.env.VITE_QSADMINAPI_HOST}/auto`}
        title={`Auto`}
        columns={columns}
        expandRelations={[]}
        storageKey={`auto-state-management-grid`}
        defaultPageSize={20}
        allowAdding={true}
        allowUpdating={true}
        allowDeleting={true}
      />
    </div>
  )
}
